var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import './TimerProgress.css';
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import Typography from '../../primitive/Typography/Typography';
const TimerProgress = (_a) => {
    var { duration, size = 220, onComplete, isPlaying, headingLabel, belowLabel = 'Remaining Time', strokeWidth = 15, trailColor = '#E9E9FF', colors = '#008CFF', rtl = false, onTimeComplete } = _a, props = __rest(_a, ["duration", "size", "onComplete", "isPlaying", "headingLabel", "belowLabel", "strokeWidth", "trailColor", "colors", "rtl", "onTimeComplete"]);
    const addingZero = (val) => {
        const time = val < 10 ? `0${val}` : val;
        return time;
    };
    const formatRemainingTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;
        const modifiedTime = hours !== 0 ? `${addingZero(hours)}:${addingZero(minutes)}` : `${addingZero(minutes)}:${addingZero(seconds)}`;
        return modifiedTime;
    };
    const renderTime = ({ remainingTime }) => {
        if (remainingTime === 0) {
            onTimeComplete(remainingTime);
            return _jsx(Typography, Object.assign({ fontSize: '54px', fontWeight: 'bold', className: "value" }, { children: " 00:00 " }), void 0);
        }
        return (_jsxs("div", Object.assign({ className: "timer" }, { children: [_jsx(Typography, Object.assign({ className: "text" }, { children: headingLabel }), void 0), _jsx(Typography, Object.assign({ fontSize: '54px', fontWeight: 'bold', className: "value" }, { children: formatRemainingTime(remainingTime) }), void 0), _jsx(Typography, Object.assign({ fontSize: '16px', fontWeight: 'normal', className: "text belowLabel" }, { children: belowLabel }), void 0)] }), void 0));
    };
    const float = rtl ? 'right' : 'left';
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: `timer-wrapper timer-progress-${float}` }, { children: _jsx(CountdownCircleTimer, Object.assign({ isPlaying: isPlaying, duration: duration, colors: colors, onComplete: (totalElapsedTime) => {
                    return [false, 0];
                }, trailColor: trailColor, size: size, strokeWidth: strokeWidth }, { children: renderTime }), void 0) }), void 0) }, void 0));
};
export default React.memo(TimerProgress);
